import { render, staticRenderFns } from "./AssignedDevicesTable.vue?vue&type=template&id=f297865c"
import script from "./AssignedDevicesTable.vue?vue&type=script&lang=js"
export * from "./AssignedDevicesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports